import DotsVerticalIcon from '../../assets/images/Icons/DotsVertical';
import React, { useState } from 'react';
import Show from '../Show/Show';
import Tooltip from '../Tooltip/Tooltip';
import { ActivityType } from '../ActivityInfo/ActivityInfo';
import { BadgeAndActivity } from './BadgeAndActivity';
import { Body1Bold } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { EditMenuExercise } from './EditMenuExercise';
import { IExerciseModel } from '../../state/stores/Exercise/ExerciseModel';
import { MarkAsDone } from './MarkAsDone';
import { ModalChallenge } from '../Challenge/ModalComplete';
import { ProgramCardWrapper, line } from './ProgramCardWrapper';
import { TouchableOpacity } from 'react-native';
import { View } from 'react-native';
import { concatPath } from '../../utils/links/concatPath';
import { contentStackKey, dashboardStackKey, exerciseKey, privateKey } from '../../constants/routeKeys';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../hooks/useStores';

export type ProgramExerciseCardsProps = {
    exerciseId: string;
    line: line;
    /** gap to the next card, which the timeline line runs through */
    marginBelow?: number;
}

const _ProgressExerciseCard = ({exerciseId, line, marginBelow}: ProgramExerciseCardsProps) => {
  const rootStore = useStores();
  const exercise: IExerciseModel = rootStore.exercise.getExercise(exerciseId);
  const [menuVisible, setMenuVisible] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);

  const onPressExercise = () => {
    router.navigate({
      pathname: concatPath([privateKey, dashboardStackKey, contentStackKey,exerciseKey ], -1) as string,
      params: {id: exerciseId}
    });
  };

  const path = rootStore.path.getPath(exercise?.path);

  const openMenu = () => {
    setMenuVisible(true);
  };
  const closeMenu = () => setMenuVisible(false);


  return(
    <>
      <ModalChallenge modalVisible={modalVisible} setModalVisible={setModalVisible} exerciseId={exerciseId} />

      <ProgramCardWrapper done={exercise?.doneToday || false} onPress={onPressExercise} line={line} marginBelow={marginBelow}>
        <View style={{flexDirection:'row', justifyContent: 'space-between'}}>
          <View style={{maxWidth: '90%'}}>
            <Body1Bold>{exercise.title}</Body1Bold>
          </View>
          <Tooltip
            isVisible={menuVisible}
            highlight={false}
            placement="left"
            onClose={closeMenu}
            // arrowSize={{width: 0, height: 0}}
            // allowChildInteraction={false}
            from={(
              <TouchableOpacity onPress={openMenu} >
                <DotsVerticalIcon size={24} color={COLORS.content['primary']} />
              </TouchableOpacity>
            )}
          >
            <EditMenuExercise exerciseId={exercise._id} completed= {!!exercise.completed} onClose={closeMenu} onDiscard={() => {
              closeMenu();
              setModalVisible(true);}}/>

          </Tooltip>

        </View>
        <BadgeAndActivity type={ActivityType.ACTION} pathId={path?._id}/>
        <Show when={!exercise?.doneToday}>
          <View style={{alignSelf:'flex-end'}}>

            <MarkAsDone onPress={() => {
              rootStore?.exercise?.setDoneToday(exercise._id);
            }} />

          </View>
        </Show>

      </ProgramCardWrapper>
    </>
  );

};

export const ProgressExerciseCard= observer(_ProgressExerciseCard);